import type { CellContext } from "@tanstack/react-table";
import type { ComponentType, ReactNode } from "react";

export const cellWithInfoProp = <
  TData,
  TValue,
  P extends { info: CellContext<TData, TValue> } = {
    info: CellContext<TData, TValue>;
  },
>(
  Component: ComponentType<P>,
  additionalProps: Omit<P, "info"> | ((info: CellContext<TData, TValue>) => P),
) => {
  return (info: CellContext<TData, TValue>): ReactNode => {
    if (typeof additionalProps === "function") {
      return <Component {...additionalProps(info)} />;
    }

    const props = {
      ...additionalProps,
      info,
    } as P;

    return <Component {...props} />;
  };
};
